import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import JobsScoutJobViewComp from './JobsScoutJobViewComp';

function JobsScoutJobView() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <JobsScoutJobViewComp />
      </div>
    </div>
  );
}

export default JobsScoutJobView;
